module.exports = __webpack_public_path__ + "img/solution1.f885dca3.png";